import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AuthService } from 'src/app/auth/auth.service';
import { from, Observable, of } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { ProductKey } from 'src/app/core/enums/ProductKey';
import { RoleFilterSelected } from 'src/app/shared/role-filter-dropdown-row/role-filter-dropdown-row.component';
import { RoleFilterIds, RoleFilterService } from 'src/app/services/role-filter.service';
import { GanttTasksResponse, OrdersServiceHomeMapResponse, ServiceCount, ServiceListResponse } from '../interfaces/HomeData.interface';
import { mockGanttData, mockMapHomeData } from '../mock/homeMockData';

@Injectable({
  providedIn: 'root',
})
export class HomeService {
  constructor(
    private http: HttpClient,
    private authService: AuthService,
    private RoleFilterService: RoleFilterService
  ) { }

  url = environment.tracking_url;

  serviceCount(roleFilter: RoleFilterSelected): Observable<ServiceCount> {
    const RoleFilterIds: RoleFilterIds = this.RoleFilterService.convertRoleFilterSelected_To_RoleFilterIds(roleFilter)

    return this.http.post<ServiceCount>(`${this.url}/fleet-manager/services/count`, RoleFilterIds);


    // return from(this.authService.getAccessToken()).pipe(
    //   switchMap((token) => {
    //     if (!token) {
    //       throw new Error('No token available');
    //     }
    //     return this.http.post<ServiceCount>(`${this.url}/fleet-manager/services/count`, RoleFilterIds, {
    //       headers: {
    //         Authorization: 'Bearer ' + token,
    //       },
    //     });
    //   })
    // );

  }

  servicesGantt(roleFilter: RoleFilterSelected): Observable<GanttTasksResponse> {
    const RoleFilterIds: RoleFilterIds = this.RoleFilterService.convertRoleFilterSelected_To_RoleFilterIds(roleFilter)
    // if (environment.useMockData) {
    //   return of(mockGanttData);
    // }
    return this.http.post<GanttTasksResponse>(`${this.url}/fleet-manager/services/gantt`, RoleFilterIds);

    // return from(this.authService.getAccessToken()).pipe(
    //   switchMap((token) => {
    //     if (!token) {
    //       throw new Error('No token available');
    //     }
    //     return this.http.post<GanttTasksResponse>(`${this.url}/fleet-manager/services/gantt`, RoleFilterIds, {
    //       headers: {
    //         Authorization: 'Bearer ' + token,
    //       },
    //     });
    //   })
    // );

  }

  servicesMap(roleFilter: RoleFilterSelected): Observable<OrdersServiceHomeMapResponse> {
    const RoleFilterIds: RoleFilterIds = this.RoleFilterService.convertRoleFilterSelected_To_RoleFilterIds(roleFilter)
    // if (environment.useMockData) {
    //   return of(mockMapHomeData);
    // }
    return this.http.post<OrdersServiceHomeMapResponse>(`${this.url}/fleet-manager/services/map`, RoleFilterIds);

    // return from(this.authService.getAccessToken()).pipe(
    //   switchMap((token) => {
    //     if (!token) {
    //       throw new Error('No token available');
    //     }
    //     return this.http.post<OrdersServiceHomeMapResponse>(`${this.url}/fleet-manager/services/map`, RoleFilterIds, {
    //       headers: {
    //         Authorization: 'Bearer ' + token,
    //       },
    //     });
    //   })
    // );
  }

  servicesList(roleFilter: RoleFilterSelected): Observable<ServiceListResponse> {
    const RoleFilterIds: RoleFilterIds = this.RoleFilterService.convertRoleFilterSelected_To_RoleFilterIds(roleFilter)
    return this.http.post<ServiceListResponse>(`${this.url}/fleet-manager/services/list`, RoleFilterIds);

    // return from(this.authService.getAccessToken()).pipe(
    //   switchMap((token) => {
    //     if (!token) {
    //       throw new Error('No token available');
    //     }
    //     return this.http.post<ServiceListResponse>(`${this.url}/fleet-manager/services/list`, RoleFilterIds, {
    //       headers: {
    //         Authorization: 'Bearer ' + token,
    //       },
    //     });
    //   })
    // );

  }
}
